<span :id="getFieldID(schema)" :class="schema.fieldClasses" v-attributes="'label'">{{ value }}</span>